import styled from "styled-components";

export const SharedContainer = styled.div`
    position: relative;
    z-index: 10;
    display: flex;

    input {
        padding: .375rem .75rem;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        width: 350px;
        max-width: 100%;
        background-color: #e9ecef;
        color: #212529;
    }

    button.copy {
        background: #fff;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border: 1px solid #e9ecef;
        padding: 0 10px;
    }

    button.copy:hover {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

    button.unlink {
        margin-left: 10px;
        color: #fff;
        background: red;
        border-radius: 5px;
        padding: 0 10px;
        background-color: #dc3545;
        border-color: #dc3545;
    }

    button.unlink:hover {
        background-color: #bb2d3b;
        border-color: #b02a37;
    }
`;
